import { RequestKind, boolean, string } from '@sb/library/base';
import { ApplyTaxesUpdateItem, DisplayItemCollection, TaxDefinitionDisplayItem, TaxDefinitionInputItem, TaxDefinitionSearchOptions, TaxDefinitionUpdateItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace TaxDefinitionsRoutes {
    export const Add = ApiRoute.Define({
        URL: 'salestax/definitions',
        Kind: RequestKind.Post,
        BodyType: TaxDefinitionInputItem,
        ResultType: string
    });

    export const Delete = ApiRoute.Define({
        URL: (taxDefinitionID: string) => `salestax/definitions/${taxDefinitionID}`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });

    export const Apply = ApiRoute.Define({
        URL: 'salestax/definitions',
        Kind: RequestKind.Patch,
        BodyType: ApplyTaxesUpdateItem,
        ResultType: boolean
    });

    export const Get = ApiRoute.Define({
        URL: (taxDefinitionID: string) => `salestax/definitions/${taxDefinitionID}`,
        Kind: RequestKind.Get,
        ResultType: TaxDefinitionDisplayItem
    });

    export const GetAll = ApiRoute.Define({
        URL: 'salestax/definitions',
        Kind: RequestKind.Get,
        ResultType: DisplayItemCollection<TaxDefinitionDisplayItem>,
        PagingAllowed: true
    });

    export const Search = ApiRoute.Define({
        URL: 'search/salestax/definitions',
        Kind: RequestKind.Post,
        OrderByType: TaxDefinitionDisplayItem,
        BodyType: TaxDefinitionSearchOptions,
        ResultType: DisplayItemCollection<TaxDefinitionDisplayItem>,
        PagingAllowed: true
    });

    export const Update = ApiRoute.Define({
        URL: (taxDefinitionID: string) => `salestax/definitions/${taxDefinitionID}`,
        Kind: RequestKind.Put,
        BodyType: TaxDefinitionUpdateItem,
        ResultType: boolean
    });
}
